export default __webpack_public_path__ + "static/media/404.936af583.webp";